import Path from '@leverege/path'
import PatchOps from '@leverege/api-patch-ops'

import Constants from './Constants'
import NotifyActions from './NotifyActions'
import AttributeTree from '~/reducers/AttributeTree'

const GET_BLUEPRINT = 'GET_BLUEPRINT';
const UPDATE_BLUEPRINT = 'UPDATE_BLUEPRINT';
const SIMULATE_BLUEPRINT = 'SIMULATE_BLUEPRINT';

const ADD_ALERT = 'ADD_ALERT'
const REMOVE_ALERT = 'REMOVE_ALERT'
const UPDATE_ALERT = 'UPDATE_ALERT'

const ADD_ATTRIBUTE = 'ADD_ATTRIBUTE';
const REMOVE_ATTRIBUTE = 'REMOVE_ATTRIBUTE';
const UPDATE_ATTRIBUTE = 'UPDATE_ATTRIBUTE';
const ADD_ATTRIBUTE_GROUP = 'ADD_ATTRIBUTE_GROUP';
const REMOVE_ATTRIBUTE_GROUP = 'REMOVE_ATTRIBUTE_GROUP';
const CHANGE_LOCAL_ATTRIBUTE_GROUP = 'CHANGE_LOCAL_ATTRIBUTE_GROUP';
const UPDATE_ALL_ATTRIBUTE_GROUP = 'UPDATE_ALL_ATTRIBUTE_GROUP';

export function getBlueprint( projectId, blueprintId ) {
  return ( dispatch, getState, api ) => {

    return api.getBlueprint( projectId, blueprintId, { children : [ 'attribute', 'alert' ], attribute : { perPage : 10000 } } )
      .then( ( sBlueprint ) => {
        dispatch( { type : GET_BLUEPRINT, blueprint : sBlueprint } )
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in getBlueprint', ex );
      } )
  };
}

export function listBlueprints( projectId ) {
  return ( dispatch, getState, api ) => {
    return api.project( projectId ).blueprints().list( {
      children : [ 'attribute' ],
      attribute : { perPage : 10000 }
    } ).then( ( pBlueprints ) => {
      dispatch( { type : Constants.GET_BLUEPRINTS, blueprints : pBlueprints } )
    } )
      .catch( ( ex ) => {
        console.log( 'ERROR in getBlueprint', ex );
      } )
    // return api.getBlueprint( projectId, blueprintId, { children : [ 'attribute', 'alert' ], attribute : { perPage : 10000 } } )
      
  };
}

export function updateBlueprint( blueprint, data ) {
  return ( dispatch, getState, api ) => {

    return api.updateBlueprint( blueprint, data )
      .then( ( bPrint ) => {
        dispatch( { type : UPDATE_BLUEPRINT, blueprint : bPrint } )
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to update blueprint', ex ) )
        console.log( 'ERROR in updateBlueprint', ex );
      } )
  };
}

export function simulateBlueprint( blueprint ) {
  return function( dispatch, getState, api ) {

    return api.simulateBlueprint( blueprint )
      .then( ( sBlueprint ) => {
        console.log( 'simulate started', sBlueprint );
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to simulate blueprint', ex ) )
        console.log( 'ERROR in simulateBlueprint', ex );
      } )
  };
}

function _addAttribute( attr ) {
  return { 
    type : ADD_ATTRIBUTE,
    attribute : attr
  };
}

export function addAttribute( blueprint, attribute ) {
  return function( dispatch, getState, api ) {
    return api.addAttribute( blueprint, attribute )
      .then( ( sAttr ) => {
        dispatch( _addAttribute( sAttr ) )
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to add attribute to blueprint', ex ) )
        console.log( 'ERROR in addAttribute', attribute, ex );
      } )
  };
}

function _removeAttribute( attribute ) {
  return {
    type : REMOVE_ATTRIBUTE,
    attribute
  };
}

export function removeAttribute( blueprint, attribute ) {
  return function( dispatch, getState, api ) {

    return api.removeAttribute( blueprint, attribute )
      .then( ( sAttr ) => {
        dispatch( _removeAttribute( attribute ) )
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to remove attribute from blueprint', ex ) )
        console.log( 'ERROR in removeAttribute', ex );
      } )
  };
}

function _updateAttribute( attribute ) {
  return {
    type : UPDATE_ATTRIBUTE,
    attribute
  };
}

export function updateAttribute( blueprint, attribute, data ) {
  return function( dispatch, getState, api ) {

    return api.updateAttribute( blueprint, attribute, data )
      .then( ( sAttr ) => {
        dispatch( _updateAttribute( sAttr ) )
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to update attribute', ex ) )
        console.log( 'ERROR in updateAttribute', ex );
      } )
  };
}

// Changes the attribute group node's name. If necessary, this
// will have to modifiy all the sub paths
export function changeAttributeGroup( blueprint, groupNode, newNodeName ) {
  // if ( isLocal( groupNode ) ) { // do it now } // else send message

  return function( dispatch, getState, api ) {

    const attrs = AttributeTree.getAllAttributes( groupNode );  
    const cPathLen = groupNode.path.length
    const path = Path( groupNode.path )
    path.changeLast( newNodeName )
    const pPath = path.path()
    
    if ( attrs == null || attrs.length == 0 ) {
      return dispatch( { type : CHANGE_LOCAL_ATTRIBUTE_GROUP, id : groupNode.id, path : pPath, name : newNodeName } )
    }

    const finalDispatch = []
    function updateAttr( index ) {
      const attr = attrs[index].attribute
      const newPath = pPath + attr.path.substring( cPathLen )
      const patchOps = PatchOps( 'path', newPath );      
      function next() {
        if ( index < attrs.length - 1 ) { 
          updateAttr( index + 1 );
        } else {
          // done - send dispatches
          for ( let n = 0; n < finalDispatch.length; n++ ) {
            dispatch( _updateAttribute( finalDispatch[n] ) )
          }
        }
      }

      api.updateAttribute( blueprint, attr, patchOps.ops() )
        .then( ( resAttr ) => {
          finalDispatch.push( resAttr )
          next()
        } )
        .catch( ( ex ) => {
          dispatch( NotifyActions.requestError( 'Failed to rename group', ex ) )
          console.log( 'error changing group name', ex )
          next()
        } )
    }
    function checkNext( ) {

    }
    updateAttr( 0 )
  }
}

export function addAttributeGroup( path ) {
  return {
    type : ADD_ATTRIBUTE_GROUP,
    path 
  }
}

export function _updateAllAttributes( attributes ) {
  return {
    type : UPDATE_ALL_ATTRIBUTE_GROUP,
    attributes
  }
}

export function removeAttributeGroup( blueprint, group ) {
  if ( AttributeTree.isNodeLocal( group ) ) {
    return {
      type : REMOVE_ATTRIBUTE_GROUP,
      path : group.path
    };
  }  
  const attrs = AttributeTree.getAllAttributes( group );
  const ids = attrs.map( ( e ) => { 
    return e.attribute.id; // each e is a AttributeTree Node. get the attribute's id.
  } );
  return function( dispatch, getState, api ) {

    return api.removeAttributes( blueprint, ids )
      .then( ( sAttr ) => {
        dispatch( {
          type : REMOVE_ATTRIBUTE_GROUP,
          path : group.path
        } )
      } )
      .catch( ( ex ) => {
        console.log( 'ERROR in removeAttributes', ex );
      } )
  }
  
}

// ALERTS
export function testAlert( blueprint, alert ) {
  return function( dispatch, getState, api ) {
    console.log( 'bp,', blueprint )
    api.testAlert( blueprint )
  }
}

export function addAlert( blueprint, alert ) {
  return function( dispatch, getState, api ) {

    return api.addAlert( blueprint, alert )
      .then( ( data ) => {
        dispatch( { type : ADD_ALERT, alert : data } )
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to add Alert', ex ) )
        console.log( 'ERROR in addAlert', attribute, ex );
      } )
  };
}

export function removeAlert( blueprint, alert ) {
  return function( dispatch, getState, api ) {

    return api.removeAlert( blueprint, alert )
      .then( ( data ) => {
        dispatch( { type : REMOVE_ALERT, alert } )
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to remove Alert', ex ) )
        console.log( 'ERROR in removeAlert', ex );
      } )
  };
}

export function updateAlert( blueprint, alert, patchOps ) {
  return function( dispatch, getState, api ) {

    return api.updateAlert( blueprint, alert, patchOps )
      .then( ( data ) => {
        dispatch( { type : UPDATE_ALERT, alert : data } )
      } )
      .catch( ( ex ) => {
        dispatch( NotifyActions.requestError( 'Failed to update Alert', ex ) )
        console.log( 'ERROR in updateAlert', ex );
      } )
  };
}

module.exports = {
  GET_BLUEPRINT,
  UPDATE_BLUEPRINT,
  SIMULATE_BLUEPRINT,
  ADD_ATTRIBUTE,
  REMOVE_ATTRIBUTE,
  UPDATE_ATTRIBUTE,
  ADD_ATTRIBUTE_GROUP,
  REMOVE_ATTRIBUTE_GROUP,
  CHANGE_LOCAL_ATTRIBUTE_GROUP,
  UPDATE_ALL_ATTRIBUTE_GROUP,

  ADD_ALERT,
  REMOVE_ALERT,
  UPDATE_ALERT,

  getBlueprint,
  listBlueprints,
  updateBlueprint,
  simulateBlueprint,

  addAttribute,
  updateAttribute,
  removeAttribute,
  addAttributeGroup,
  removeAttributeGroup,
  changeAttributeGroup,

  addAlert,
  removeAlert,
  updateAlert,
  testAlert
}
